//React
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import {  useTheme } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { publicMenu } from 'constants/index';
import { IconButton, Drawer, CssBaseline, AppBar , Toolbar, Typography, Button, Divider, Icon, Fab, Tooltip, Badge, makeStyles } from '@material-ui/core';
//Router
import PrivateRoute from 'commons/PrivateRoute';
import { useHistory } from "react-router-dom";
import { Route,  Switch, Link } from 'react-router-dom';
//Icon
import {Home, Input, Person, HelpOutline, Menu, ChevronLeft, ChevronRight, Computer, Description} from '@material-ui/icons/';
//components
import HomePage from 'pages/Home/';
import Login from 'pages/Security/Login/';
import Profile from 'pages/Security/Profile/';
import UserAccount from 'pages/Security/Login/FormElements/UserAccount';
import VerticalMenu from 'components/VerticalMenu';
import PerfilDelUsuario from 'pages/UserProfile';
import Footer from 'pages/Home/Footer2';
import PaginaEnMantenimiento from 'pages/PageInMaintenance'
//componentes GEOEmpadronamiento
import SolicitudesDeEmpadronamiento from 'pages/GeoEmpadronamiento/SolicitudesDeEmpadronamiento';
//Componente para usarse por empresa para generar citas de empadronamiento.
import CitasDeEmpadronamiento from 'pages/CitasDeEmpadronamiento';
import SolicitudesExtranjero from 'pages/solicitudesExtranjero';
// componente para mostrar las estadisticas de solicitudes
import EstadisticaDeSolicitudes from 'pages/Reportes/EstadisticasSolicitudes'
// componente para mostrar las estadisticas de solicitudes para jefes
import EstadisticaDeSolicitudesParaJefes from 'pages/Reportes/EstadisticasSolicitudesParaJefes'
// componente para mostrar las estadisticas de solicitudes para coordinadores
import EstadisticasSolicitudesParaCoordinadores from 'pages/Reportes/EstadisticasSolicitudesParaCoordinadores'
// componente para mostrar el modulo de fallecidos
import ModuloFallecidos from 'pages/ModuloFallecidos'
// componente para mostrar el modulo de fallecidos
import ModuloDeSuspendidos from 'pages/ModuloDeSuspendidos'
// componente para mostrar el modulo de consulta de datos faltante de RENAP
import ConsultaApiRenapPorDataFaltante from 'pages/ConsultaApiRenapPorDataFaltante'
// componente para descargar constancias de empadronamiento, reimpresion
import GenerarSolicitudReimpresionConstancia from 'pages/GeoEmpadronamiento/GenerarSolicitudReimpresionConstancia'
// componente para descargar constancia de acta de vencimiento de plazo para declarar cambio de residencia de un municipio a otro
import ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro from 'pages/Reportes/ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro'
// componente para descargar estadisticas de cambio de residencia de un municipio a otro
import ReporteEstadisticasCierreCambioResidencia from 'pages/Reportes/ReporteDeEmpadronamientoYActualizacionesDeptoYMuniPorEmpadronadores'
// componente para generar y descargar reporte detallado de totales de empadronamiento y actualizaciones a nivel nacional
import ReporteDetalladoDeTotalesDeEmpadronamientoActualizacionesANivelNacional from 'pages/Reportes/ReporteDetalladoDeTotalesEmpadronamientoActualizacionesNacional'
// componente para crear usuarios en el SSO
import ModuloCreacionUsuariosEnElSSO from 'pages/CrearUsuariosSSO'
// componente para el listado de reportes
import ListadoDeReportes from 'pages/Reportes'
// componente para reporte por puesto de empadronamiento
import ReportePorPuestoDeEmpadronamiento from 'pages/Reportes/ReportePorPuestoDeEmpadronamiento'
// componente para reporte por sexo (mujeres y hombres)
import ReportePorSexo from 'pages/Reportes/ReporteDetalladoAgrupadosPorDepartamentoYGenero'
// componente para reporte Detallado Agrupado Por Rango Edades
import ReporteDetalladoAgrupadoPorRangoEdades from 'pages/Reportes/ReportesEstadisticos/ReporteDetalladoAgrupadoPorRangoEdades'
// componente para reporte de ciudadanos guatemaltecos residentes en el extranjero
import ReporteDeCiudadanosGuatemaltecosResidentesEnElExtranjero from 'pages/Reportes/ReportesEstadisticos/ReporteDeCiudadanosGuatemaltecosResidentesEnElExtranjero'
// componente para por aldea, caserio y comunidades
import ReportePorAldeaCaseriosYComunidades from 'pages/Reportes/ReportesEstadisticos/ReportePorAldeaCaseriosYComunidades'
// cambio de puesto de empadronamiento para usuarios
import CambioDePuestoDeEmpadronamientoParaUsuarios from 'pages/CambioDePuestoParaUsuarios'
//reporte del sistema de fallecidos
import ReporteDeFallecidos from 'pages/ModuloFallecidos/ReportesDeFallecidos/ReportePrevioFallecidosEstatusSuspendidosYPorFallecidos'
// generar informe de cierre de padron para operadores
import ComponenteParaGenerarInformeCierrePadronOperadores from 'pages/CierrePadron/Operadores'
import ComponenteParaGenerarInformeCierrePadronDelegados from 'pages/CierrePadron/Delegados'
import ComponenteParaGenerarInformeCierrePadronAdministrador from 'pages/CierrePadron/Admin'

//Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
//styles
import {useStyles} from './Style';
import EstadisticasEmpadronamientoYActualizacion from 'pages/Reportes/estadisticasEmpadronamientoYActualizaciones/';
import Title from 'components/TitleWithIcon';
import CambiosRealizadosEnElSistema from 'pages/CambiosRealizadosEnElSistema';
import { useSelector } from 'react-redux'
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import ComponenteTotalDeRangosDisponibles from 'pages/TotalDeRangosDisponibles';
import ComponenteGenerarSolicitudDelegacion from 'pages/GeoEmpadronamiento/SolicitudesDeEmpadronamiento/SolicitudesNuevas/ComponenteGenerarSolicitudDelegacion'

const MenuComponent=(props)=> {
    const rangoNoBoletas = useSelector(state => state.solicitudEmpadronamiento.rangoNoBoletas)
    const classes = useStyles();
    const theme = useTheme();
    var authenticated =props.authenticated;
    const [open, setOpen] = React.useState(false);
    const [openModalRangoDeBoletas, setOpenModalRangoDeBoletas] = useState(false);
    let history = useHistory();

    const onLogout =()=>{
        let userAccount = new UserAccount();
        userAccount.logout();
        props.LOGOUT();
        props.SET_MENU(publicMenu);
        // history.push("/PageInMaintenance",{})
        history.push("/login",{})
    }

    const handleDrawerClose=(props)=> {
        setOpen(false);
    }

    const handleDrawerOpen=()=> {
        setOpen(true);
    }
 
    const [modalCambiosSistema, setModalCambiosSistema] = useState(false);
    const [invisible, setInvisible] = React.useState(false);
    const [openMessage, setOpenMessage] = React.useState(true);

    const abrirModalCambiosDelSistema = (event)=> {
        setOpenMessage(false);
        if(!invisible) setInvisible(!invisible);
        setModalCambiosSistema(true)
    }
    const cerrarModalCambiosDelSistema = ()=> {
        setModalCambiosSistema(false)        
    }
    
    const themeMessage = createMuiTheme({
        overrides: {
          MuiTooltip: {
            tooltip: {
              fontSize: "1rem",
              color: "white",
              backgroundColor: "#205690",
              borderRadius: 10,
              padding: '1rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              textAlign: 'center'
            },
            arrow: {
                color: '#205690',
              },            
          }
        }
      });
      const useStylesBootstrap = makeStyles((theme) => ({
        arrow: {
          color: '#205690',
        },
        tooltip: {
          backgroundColor: '#205690',
        },
      }));
      
      function BootstrapTooltip(props) {
        const classes = useStylesBootstrap();
      
        return <Tooltip arrow classes={classes} {...props} />;
      }    

    //   useEffect(() => {
    //     if(rangoNoBoletas?.boletasFaltantes)
    //         if(
    //             props.currentUser?.email === 'achiroy@tse.org.gt' || props.currentUser?.email === 'jabiche@tse.org.gt'||
    //             props.currentUser?.email === 'ctorres@tse.org.gt' || props.currentUser?.email === 'mjmerida@tse.org.gt' ||
    //             props.currentUser?.email === 'sfajardo@tse.org.gt' || props.currentUser?.email === 'empadronamiento@tse.org.gt'                
    //         ) {
    //             if(rangoNoBoletas?.boletasFaltantes === 200 || rangoNoBoletas?.boletasFaltantes === 100 || rangoNoBoletas?.boletasFaltantes <= 75)
    //                 showMessagePersonalizedPosition('warning','¡Advertencia! ', ('Rango de Número de boletas restantes: '+rangoNoBoletas?.boletasFaltantes),'center')
    //         }
    //   },[rangoNoBoletas?.boletasFaltantes])

      const FuncionAbrirModalDeRangoDeBoletas = () => {
        setOpenModalRangoDeBoletas(true);
      }
      const FuncionCerrarModalDeRangoDeBoletas = () => {
        setOpenModalRangoDeBoletas(false);
      }
  return (
    <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed"
                className={clsx(classes.appBar, {
                [classes.appBarShift]: open,
                })}>
            <Toolbar className={classes.toolbar}>
                
                {/* { props.authenticated ? (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <Menu />
                    </IconButton>
                ):""}               */}
                <Typography variant="h6" className={classes.title} >
                    <Link className={classes.appTitle} to="/">
                        <img className={classes.appIcon} src="assets/WhiteIcon.svg"  alt="fireSpot"/>
                        Portal Web GEOEMPADRONAMIENTO TSE
                    </Link>
                </Typography> 
                { props.authenticated ? (
                <div>
                    {/* {
                        (rangoNoBoletas?.boletasFaltantes) && (
                            (
                                props.currentUser?.email === 'achiroy@tse.org.gt' || props.currentUser?.email === 'jabiche@tse.org.gt'||
                                props.currentUser?.email === 'ctorres@tse.org.gt' || props.currentUser?.email === 'mjmerida@tse.org.gt' ||
                                props.currentUser?.email === 'sfajardo@tse.org.gt' || props.currentUser?.email === 'empadronamiento@tse.org.gt'
                            ) ? (
                                (rangoNoBoletas?.boletasFaltantes >=300) ? 
                                    <Button className={classes.button} style={{backgroundColor: '#157f15'}} color="inherit" onClick={FuncionAbrirModalDeRangoDeBoletas}>
                                        <span className={classes.title_text}>Rango Boletas: {rangoNoBoletas?.boletasFaltantes}</span>
                                    </Button>
                                : (rangoNoBoletas?.boletasFaltantes >=200 && rangoNoBoletas?.boletasFaltantes<300) ? 
                                    <Button className={classes.button} style={{backgroundColor: '#e79000'}} color="inherit">
                                        <span className={classes.title_text}>Rango Boletas: {rangoNoBoletas?.boletasFaltantes}</span>
                                    </Button>
                                : (rangoNoBoletas?.boletasFaltantes<200) ? 
                                    <Button className={classes.button} style={{backgroundColor: '#CB1C00', border: '1px solid white'}} color="inherit">
                                        <span className={classes.title_text}>Rango Boletas: {rangoNoBoletas?.boletasFaltantes}</span>
                                    </Button> :''
                            ) : ''
                        )
                    } */}
                    <Button>                        
                        {/* <ClickAwayListener > */}
                            <div>
                            <MuiThemeProvider theme={themeMessage}>
                                <BootstrapTooltip 
                                    classes={{ tooltip: classes.customWidth }}
                                    PopperProps={{
                                    disablePortal: true,
                                    }}
                                    // onClose={handleTooltipClose}
                                    open={openMessage}
                                    disableFocusListener
                                    disableHoverListener
                                    disableTouchListener
                                    title="Hay nuevas actualizacones en el sistema."
                                >
                                    <Button className={classes.button} color="inherit" onClick={abrirModalCambiosDelSistema}>
                                        <Badge color="primary" variant="dot" invisible={invisible} className={classes.badge}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}                        
                                        >
                                            <Icon style={{ color:'white'}}><Computer /></Icon>
                                            <span style={{ color:'white'}}>Versión 2.2.4</span>
                                        </Badge>                        
                                    </Button>
                                </BootstrapTooltip >
                            </MuiThemeProvider>                                
                            </div>
                        {/* </ClickAwayListener> */}
                    </Button>                
                    <Button className={classes.button} color="inherit" href='https://ayudaportalwebinterno.tse.org.gt/'>
                        <Icon className={classes.icon}><HelpOutline /></Icon>
                        <span className={classes.title_text}>Ayuda</span>
                    </Button>                    
                    <Button className={classes.button} color="inherit"  to='/' component={Link}> 
                        <Icon className={classes.icon}><Home/></Icon> 
                        <span className={classes.title_text}>Menú Principal</span>
                    </Button> 
                    <Button className={classes.button} color="inherit"  to='/PerfilDelUsuario' component={Link} > 
                            <Icon className={classes.icon}><Person/></Icon>
                            <span className={classes.title_text}>Mi Perfil</span>
                    </Button>
                    <Button className={classes.button} color="inherit" 
                            onClick={onLogout} > 
                            <Icon className={classes.icon}><Input/></Icon>
                            <span className={classes.title_text}>Cerrar sesión</span>
                    </Button>
                </div>
                ):(
                <div>
                    <Button className={classes.button} color="inherit" href='https://ayudaportalwebinterno.tse.org.gt/'>
                        <Icon className={classes.icon}><HelpOutline /></Icon>
                        <span className={classes.title_text}>Ayuda</span>
                    </Button>                     
                    {/* <Button className={classes.button} color="inherit" to='/login' 
                            component={Link}>
                        <Icon   className={classes.icon}>person</Icon>
                    {"   Iniciar sesión"} </Button> */}
                </div>
                )}
            </Toolbar>
        </AppBar>
        
        <Drawer className={classes.drawer}  variant="persistent"    anchor="left"
                open={open} classes={{  paper: classes.drawerPaper,}}               
        >
            <div className={classes.drawerHeader}>
                <Fab color="primary" aria-label="add" className={classes.fab}>
                    <img className={classes.image}src={"/svgMenu/luz.svg"} alt="Italian Trulli"></img>
                </Fab>
                Bienvenido
                <IconButton className={classes.iconMenu}  onClick={handleDrawerClose}>
                    {theme.direction === 'ltr' ? <ChevronLeft /> : <ChevronRight />}
                </IconButton>
            </div>
            <Divider />
                <VerticalMenu/>
            <Divider variant="middle"/>
        </Drawer>
        
        <main className={clsx(classes.content, {  [classes.contentShift]: open,})}>
            <Switch>
                <Route exact path="/"   render={(props) => <HomePage  authenticated={authenticated} currentUser={props.currentUser} {...props} />}></Route> 
                <PrivateRoute path="/profile" authenticated={authenticated} currentUser={props.currentUser} component={Profile}></PrivateRoute>
                <PrivateRoute path="/PerfilDelUsuario" authenticated={authenticated} currentUser={props.currentUser} component={PerfilDelUsuario}></PrivateRoute>
                <PrivateRoute path="/solicitudesDeEmpadronamiento" authenticated={authenticated} currentUser={props.currentUser} component={SolicitudesDeEmpadronamiento}></PrivateRoute>
                <PrivateRoute path="/citasDeEmpadronamiento" authenticated={authenticated} currentUser={props.currentUser} component={CitasDeEmpadronamiento}></PrivateRoute>
                <PrivateRoute path="/solicitudesDeEmpadronamientoExtranjero" authenticated={authenticated} currentUser={props.currentUser} component={SolicitudesExtranjero}></PrivateRoute>
                <PrivateRoute path="/estadisticasSolicitudes" authenticated={authenticated} currentUser={props.currentUser} component={EstadisticaDeSolicitudes}></PrivateRoute>
                <PrivateRoute path="/estadisticasSolicitudesGeneral" authenticated={authenticated} currentUser={props.currentUser} component={EstadisticaDeSolicitudesParaJefes}></PrivateRoute>
                <PrivateRoute path="/estadisticasSolicitudesCoordinadores" authenticated={authenticated} currentUser={props.currentUser} component={EstadisticasSolicitudesParaCoordinadores}></PrivateRoute>
                <PrivateRoute path="/listadoFallecidos" authenticated={authenticated} currentUser={props.currentUser} component={ModuloFallecidos}></PrivateRoute>
                <PrivateRoute path="/listadoDeSuspendidos" authenticated={authenticated} currentUser={props.currentUser} component={ModuloDeSuspendidos}></PrivateRoute>
                <PrivateRoute path="/ConsultaSolicitud" authenticated={authenticated} currentUser={props.currentUser} component={ConsultaApiRenapPorDataFaltante}></PrivateRoute>
                <PrivateRoute path="/constanciaEmpadronamiento" authenticated={authenticated} currentUser={props.currentUser} component={GenerarSolicitudReimpresionConstancia}></PrivateRoute>
                <PrivateRoute path="/actaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro" authenticated={authenticated} currentUser={props.currentUser} component={ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro}></PrivateRoute>
                <PrivateRoute path="/reporteEstadisticasCierreCambioResidencia" authenticated={authenticated} currentUser={props.currentUser} component={ReporteEstadisticasCierreCambioResidencia}></PrivateRoute>
                <PrivateRoute path="/reporteDetalladoDeTotalesDeEmpadronamientoActualizacionesANivelNacional" authenticated={authenticated} currentUser={props.currentUser} component={ReporteDetalladoDeTotalesDeEmpadronamientoActualizacionesANivelNacional}></PrivateRoute>
                <PrivateRoute path="/user" authenticated={authenticated} currentUser={props.currentUser} component={ModuloCreacionUsuariosEnElSSO}></PrivateRoute>

                <PrivateRoute path="/estadisticasEmpadronamientoYActualizacion" authenticated={authenticated} currentUser={props.currentUser} component={EstadisticasEmpadronamientoYActualizacion}></PrivateRoute>
                <PrivateRoute path="/reportes" authenticated={authenticated} currentUser={props.currentUser} component={ListadoDeReportes}></PrivateRoute>
                <PrivateRoute path="/reportePorPuestoDeEmpadronamiento" authenticated={authenticated} currentUser={props.currentUser} component={ReportePorPuestoDeEmpadronamiento}></PrivateRoute>
                <PrivateRoute path="/reporteDetalladoAgrupadoPorDepartamentoYGenero" authenticated={authenticated} currentUser={props.currentUser} component={ReportePorSexo}></PrivateRoute>
                <PrivateRoute path="/reporteDetalladoAgrupadoPorRangoEdades" authenticated={authenticated} currentUser={props.currentUser} component={ReporteDetalladoAgrupadoPorRangoEdades}></PrivateRoute>
                <PrivateRoute path="/reporteRecuentoEmpadronadosEnExtranjero" authenticated={authenticated} currentUser={props.currentUser} component={ReporteDeCiudadanosGuatemaltecosResidentesEnElExtranjero}></PrivateRoute>
                <PrivateRoute path="/reporteRecuentoEmpadronadosPorComunidad" authenticated={authenticated} currentUser={props.currentUser} component={ReportePorAldeaCaseriosYComunidades}></PrivateRoute>
                
                <PrivateRoute path="/cambioDePuestoDeEmpadronamiento" authenticated={authenticated} currentUser={props.currentUser} component={CambioDePuestoDeEmpadronamientoParaUsuarios}></PrivateRoute>
                {/* reporte para fallecidos */}
                <PrivateRoute path="/reporteFallecidosPdf" authenticated={authenticated} currentUser={props.currentUser} component={ReporteDeFallecidos}></PrivateRoute>
                <PrivateRoute path="/generar-informe-cierre-operador" authenticated={authenticated} currentUser={props.currentUser} component={ComponenteParaGenerarInformeCierrePadronOperadores}></PrivateRoute>
                <PrivateRoute path="/generar-informe-cierre-delegado" authenticated={authenticated} currentUser={props.currentUser} component={ComponenteParaGenerarInformeCierrePadronDelegados}></PrivateRoute>
                <PrivateRoute path="/generar-informe-cierre-admin" authenticated={authenticated} currentUser={props.currentUser} component={ComponenteParaGenerarInformeCierrePadronAdministrador}></PrivateRoute>
                <PrivateRoute path="/generarSolicitudDeDelegacion" authenticated={authenticated} currentUser={props.currentUser} component={ComponenteGenerarSolicitudDelegacion}></PrivateRoute>


                <Route path="/login"    render={(props) => <Login/>}></Route>
                {/* <Route path="/PageInMaintenance"    render={(props) => <PaginaEnMantenimiento/>}></Route> */}
            </Switch>
        </main>
        <Footer></Footer> 
        <CambiosRealizadosEnElSistema 
                open={modalCambiosSistema}
                fullScreen={true}
                closeModal={cerrarModalCambiosDelSistema}
                iconToolbar={<Description />}
                // titleToolbar={'Cambios realizados en el sistema - versión 2.2.2'}
        />
        {
            openModalRangoDeBoletas && (
                <ComponenteTotalDeRangosDisponibles 
                    open={openModalRangoDeBoletas}
                    maxWidth={'md'}
                    fullWidth={true}
                    closeModal={FuncionCerrarModalDeRangoDeBoletas}
                    iconToolbar={''}
                    titleToolbar={'Información de rangos'}
                    rangoNoBoletas={rangoNoBoletas}
                />
            )
        }
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuComponent);
